module.exports = __webpack_public_path__ + "static/mergesort-code-example-f3d6005e9bf035e10b68d3ae51d87059.png";